import RestDataService from '@yakit/core/api/RestDataService'

/**
 * User Rest Api additions
 */
export default function(opts) {
  const api = RestDataService({ ...opts, key: 'rally/user' })

  /**
   * Change the logged-in user's password.
   * PUT /api/rally/user/password
   */
  api.changePassword = async ({ newPassword, repassword }: { newPassword: string, repassword: string }) => {
    return api.put({ path: 'password', json: { newPassword, repassword } })
  }

  return api
}
